<template>
    <!-- Zaslepka wykresu - trzyma wysokosc kontenera, zanim SciChart zdazy sie zainicjalizowac. -->
    <div class="chart-skeleton" :style="{ height: height + 'px' }">
        <div class="chart-skeleton__plot">
            <div v-for="(bar, index) in bars" :key="index" class="chart-skeleton__bar" :style="{ height: bar + '%' }"></div>
        </div>
        <div class="chart-skeleton__axis"></div>
    </div>
</template>

<script>
export default {
    name: 'ChartSkeleton',
    props: {
        height: {
            type: Number,
            default: 260
        }
    },
    data() {
        return {
            // Staly uklad slupkow - losowanie powodowaloby migotanie przy kazdym przerysowaniu.
            bars: [30, 48, 40, 62, 55, 74, 60, 82, 70, 90, 66, 78]
        }
    }
}
</script>

<style scoped>
.chart-skeleton {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px 5px 0 5px;
}

.chart-skeleton__plot {
    display: flex;
    flex: 1;
    align-items: flex-end;
    gap: 6px;
    min-height: 0;
}

.chart-skeleton__bar {
    flex: 1;
    border-radius: 4px 4px 0 0;
    background: linear-gradient(90deg, #4d5b5d 25%, #5c6b6d 37%, #4d5b5d 63%);
    background-size: 400% 100%;
    animation: chart-skeleton-loading 1.4s ease infinite;
}

.chart-skeleton__axis {
    height: 8px;
    margin-top: 8px;
    border-radius: 4px;
    background: linear-gradient(90deg, #4d5b5d 25%, #5c6b6d 37%, #4d5b5d 63%);
    background-size: 400% 100%;
    animation: chart-skeleton-loading 1.4s ease infinite;
}

@keyframes chart-skeleton-loading {
    0% { background-position: 100% 50%; }
    100% { background-position: 0 50%; }
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/ChartSkeleton.vue